import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useButton } from '~Hooks';

/** Short enough that the press never trails the finger. */
const TRANSITION = '100ms ease';

const SegmentButton = styled.button<{ active: boolean; touching?: boolean }>`
  flex: 1;
  height: 44px;
  border: 0;
  border-radius: 9px;
  cursor: pointer;
  font-family: 'Eina01', 'HelveticaNeue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  background: ${({ active, touching }) =>
    active ? 'var(--colorBlueGray1000)' : touching ? 'var(--colorBlueGray1100)' : 'transparent'};
  color: ${({ active }) => (active ? 'var(--colorWhite)' : 'var(--colorBlueGray200)')};
  transition: background ${TRANSITION}, color ${TRANSITION};
`;

interface Props {
  label: string;
  active: boolean;
  onSelect: () => void;
}

/** One option in a SegmentedControl. Own component so each segment gets its own useButton. */
const Segment: FC<Props> = ({ label, active, onSelect }) => {
  const button = useButton({ onClick: onSelect });

  return (
    <SegmentButton type="button" active={active} {...button}>
      {label}
    </SegmentButton>
  );
};

export default Segment;
